import Component from '@glimmer/component';
// @ts-ignore
import { focusTrap } from 'ember-focus-trap';
import BvMenu from 'volta/components/bv-menu';
import BvPopover from 'volta/components/bv-popover';
import classNames from 'volta/helpers/class-names';

import type { BvMenuSectionSignature } from 'volta/components/bv-menu/section';
import type { ComponentLike } from '@glint/template';
import type { BvMenuSignature } from 'volta/components/bv-menu';
import type { BvPopoverApi, BvPopoverSignature } from 'volta/components/bv-popover';

type PopoverProps = Pick<
  BvPopoverSignature['Args'],
  | 'horizontalPosition'
  | 'matchTriggerWidth'
  | 'verticalPosition'
  | 'disabled'
  | 'initiallyOpened'
  | 'onOpen'
  | 'onClose'
  | 'rootEventType'
  | 'size'
>;

export interface BvDropdownMenuSignature {
  Args: PopoverProps & {
    items?: BvMenuSignature['Args']['items'];
    sections?: BvMenuSignature['Args']['sections'];
    closeOnItemAction?: boolean;
  };
  Element: HTMLDivElement;
  Blocks: {
    trigger: [BvPopoverApi];
    menu: [ComponentLike<BvMenuSectionSignature>];
  };
}

export default class BvDropdownMenuComponent extends Component<BvDropdownMenuSignature> {
  get closeOnItemAction() {
    return this.args.closeOnItemAction ?? true;
  }
  <template>
    <BvPopover
      @isMenu={{true}}
      @disabled={{@disabled}}
      @horizontalPosition={{@horizontalPosition}}
      @verticalPosition={{@verticalPosition}}
      @initiallyOpened={{@initiallyOpened}}
      @matchTriggerWidth={{@matchTriggerWidth}}
      @onOpen={{@onOpen}}
      @rootEventType={{@rootEventType}}
      @size={{@size}}
      @initialFocusElement='.bv-menu'
      @onClose={{@onClose}}
      class={{classNames 'bv-dropdown-menu'}}
      as |popover|
    >
      {{#if (has-block 'trigger')}}
        {{yield popover to='trigger'}}
      {{/if}}
      <popover.Content
        {{focusTrap isActive=popover.isOpen focusTrapOptions=popover.focusTrapOptions}}
      >
        <BvMenu
          @items={{@items}}
          @sections={{@sections}}
          @onAnyItemAction={{if this.closeOnItemAction popover.close undefined}}
          as |Section|
        >
          {{#if (has-block 'menu')}}
            {{yield Section to='menu'}}
          {{/if}}
        </BvMenu>
      </popover.Content>
    </BvPopover>
  </template>
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvDropdownMenu: typeof BvDropdownMenuComponent;
    'bv-dropdown-menu': typeof BvDropdownMenuComponent;
  }
}
